import "./gender.scss";
import "./genderResponsive.sass";
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import { Hero } from "../../container/index";
import React, { useState } from "react";
import { News, Helm } from "../../components/index";
import { useEffect } from "react";
import { request } from "../../api/request";
import TomchiLogo from '../../assets/icons/TOMCHILOGO.png'
import { useDispatch } from "react-redux";
import { set_data } from "../../redux/action";
import { useSelector } from "react-redux";
import parser from "html-react-parser";
import QRcode from '../../assets/qrCode.png'
const GenderMaterial = () => {

    const dispatch = useDispatch();

    const event = useSelector((state) => state.data.data);
    const lang = useSelector((state) => state.data.lang);
    const news = useSelector(state => state.data.news)
    const [categories, setCategories] = useState([])

    const [active, setActive] = useState(0)

    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        request
            .get(`/content/all/event?sort=DESC&sortby=id&lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => dispatch(set_data(res.data)))
            .catch((err) => console.log(err));

        request
            .get(`/segment/all/event_category?lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));
    }, [lang]);
    return (
        <div className="events-page">
            {/*<Helm id={"37"}/>*/}

            <div className="hero-page">
                <Hero
                    id={"663"}
                    nameOne={
                        lang === "uz"
                            ? "Bosh sahifa"
                            : lang === "ru"
                                ? "Домой"
                                : lang === "en"
                                    ? "Home page"
                                    : ""
                    }
                    nameTwo={
                        lang === "uz"
                            ? "Gender konsepsiyasi"
                            : lang === "ru"
                                ? "Открытые данные"
                                : lang === "en"
                                    ? "Open data"
                                    : ""
                    }
                    linkOne={"/"}
                    linkTwo={"/gender-konsepsiya"}
                />
            </div>

            <div className="inner-pages container">
                <div className="col-one">
                    <div className="heading">
                        <h1 className="news-holder">Kategoriya</h1>
                    </div>
                    <div className="events-category">
                        <div className="events-category">
                            <button
                                onClick={() => history.push('/gender-konsepsiya')}
                                className={currentPath === '/gender-konsepsiya' ? 'active' : ''}
                            >
                                Gender konsepsiyasi
                            </button>
                            <button
                                onClick={() => history.push('/gender-material')}
                                className={currentPath === '/gender-material' ? 'active' : ''}
                            >
                                Rasmiy taqdimot materiallari
                            </button>
                            <button
                                onClick={() => history.push('/gender-hikoya')}
                                className={currentPath === '/gender-hikoya' ? 'active' : ''}
                            >
                                Loyiha hikoyalari
                            </button>
                        </div>
                    </div>
                    <div className="tomchi">
                        <img src={QRcode} alt=""/>
                    </div>
                    <div className="tomchi-links">
                        <img src={TomchiLogo} alt=""/>
                        <h3 style={{
                            fontSize: '13px'
                        }} className='tomchi-title'>QR code skanerlang va Tomchi mobil ilovasini yuklab oling.</h3>
                    </div>
                </div>

                <div className="col-two">
                    <div className="heading">
                        <h1 className="news-holder">Suv xo'jaligida gender konsepsiyasi</h1>
                    </div>
                    <h2>
                        <strong>Файл</strong>
                    </h2>
                    <p>
                        <span style={{fontSize: "14px"}}>
                            <a
                                href="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/gender-concept-rt-16-may-2025uz.pdf"
                                target="_blank"
                                style={{
                                    color: "rgb(57, 135, 243)",
                                    border: "none",
                                    padding: "5px 30px 5px 22px",
                                    fontFamily: "Poppins",
                                    fontWeight: 600,
                                    background: "rgba(57, 135, 243, 0.2)",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    margin: "0px 5px 5px 0px"
                                }}
                            >
                              Кенгашининг кенгайтирилган йиғилиши дастури
                            </a>
                        </span>
                    </p>

                    <h2>
                        <strong>Фото ва Видео материал</strong>
                    </h2>
                    <p>
                        <span style={{fontSize: "14px"}}>
                            <a
                                href="https://drive.google.com/drive/folders/10sc5hN7WFPKj8U_NgMK6JE04MPjxarTf?usp=drive_link"
                                target="_blank"
                                style={{
                                    color: "rgb(57, 135, 243)",
                                    border: "none",
                                    padding: "5px 30px 5px 22px",
                                    fontFamily: "Poppins",
                                    fontWeight: 600,
                                    background: "rgba(57, 135, 243, 0.2)",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    margin: "0px 5px 5px 0px"
                                }}
                            >
                              Фото
                            </a>
                            <a
                                href="https://drive.google.com/drive/folders/1zCtY-04P91CbQw1Cm4Lnsh_n5yzNNDEw?usp=drive_link"
                                target="_blank"
                                style={{
                                    color: "rgb(57, 135, 243)",
                                    border: "none",
                                    padding: "5px 30px 5px 22px",
                                    fontFamily: "Poppins",
                                    fontWeight: 600,
                                    background: "rgba(57, 135, 243, 0.2)",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    margin: "0px 5px 5px 0px"
                                }}
                            >
                              Видео
                            </a>
                        </span>
                    </p>
                </div>

                <div className="col-thr">
                    <h1 className="news-holder">
                        {lang === "uz"
                            ? "So’ngi yangiliklar"
                            : lang === "ru"
                                ? "последние новости"
                                : lang === "en"
                                    ? "Last news"
                                    : ""}
                    </h1>
                    {news && news.status === 1 ? (
                        news.data &&
                        news.data.map((el, index) => (
                            <News
                                date={el.created_on}
                                key={index}
                                title={el.title}
                                id={el.id}
                            />
                        ))
                    ) : (
                        <h1>Loading ...</h1>
                    )}
                </div>
            </div>

            <div className="margin"></div>
        </div>
    );
};

export default GenderMaterial;
